import { useDispatch, useSelector } from 'react-redux'
import { setCommonModalState } from '../../../../store/slices/commonModalSlice'
import { CommonModals } from '../../../types/enums'
import { toggleMapSlider } from '../../../../store/slices/gMapSlice'
import { selectConnectedList } from '../../../../store/slices/wsSlice'

export const useBar = () => {
  const dispatch = useDispatch()
  const connectedList = useSelector(selectConnectedList)

  const setLoginModalState = (state: boolean) =>
    dispatch(setCommonModalState({ modal: CommonModals.LOGIN, state }))

  const toggleMapSliderAction = () => {    
    dispatch(toggleMapSlider())
    // navigate('#map')
  }

  return { setLoginModalState, toggleMapSliderAction, connectedList }
}
